import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import { Employee, EmployeePageHeader } from "./components";

import { useEmployeeDetails } from "@hooks/HRM/employee/useEmployee";
import { useUser } from "@hooks/useUser";
import { getAccess } from "@helpers/permissionController";

function EmployeeDetails() {
  const [isProfileDisabled, setIsProfileDisabled] = useState<boolean>(false);

  const [isEditEmployee, setIsEditEmployee] = useState<boolean>(false);

  const [isCreateEmployee, setIsCreateEmployee] = useState<boolean>(false);

  const { user } = useUser();
  const { realm_roles: roles } = user || {};

  const { id } = useParams();
  const userData = useEmployeeDetails(Number(id));

  useEffect(() => {
    const editPermission = getAccess(roles, "EMPLOYEE_EDIT_PAGE");
    const createPermission = getAccess(roles, "EMPLOYEE_CREATE_PAGE");
    setIsCreateEmployee(createPermission);
    setIsEditEmployee(editPermission);
    setIsProfileDisabled(userData?.unitId === null);
  }, [userData, roles]);

  return (
    <div className="w-100 px-10 pt-10">
      <EmployeePageHeader
        id={Number(id)}
        isProfileDisabled={isProfileDisabled}
      />
      <div className="pt-10">
        <Employee
          id={id ? Number(id) : null}
          isProfileDisabled={isProfileDisabled}
          isEditEmployee={isEditEmployee}
          isCreateEmployee={isCreateEmployee}
        />
      </div>
    </div>
  );
}

function Profile() {
  const [isProfileDisabled, setIsProfileDisabled] = useState<boolean>(false);

  const { user } = useUser();

  const id = user?.employeeMasterId;
  const userData = useEmployeeDetails(id as number);

  useEffect(() => {
    setIsProfileDisabled(userData?.unitId === null);
  }, [userData]);

  return (
    <div className="w-100 px-10 pt-10">
      <EmployeePageHeader
        id={Number(id)}
        isProfileDisabled={isProfileDisabled}
      />
      <div className="pt-10">
        <Employee
          id={id}
          isProfileDisabled={isProfileDisabled}
          isEditEmployee={true}
          isCreateEmployee={true}
        />
      </div>
    </div>
  );
}

export { Profile };
export default EmployeeDetails;
